export const DEVICE_OS = {
  WINDOWS: 'WINDOWS',
  ANDROID: 'ANDROID',
  IOS: 'IOS'
}
export const MT_APP_ID = {
  WINDOWS: 'WINDOWS',
  ANDROID: 'https://play.google.com/store/apps/details?id=dk.telmore.app',
  IOS: 'https://apps.apple.com/dk/app/mit-telmore/id915471094'
}
